module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("2")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXT DAY")]), _vm._v(" was no more peaceful among the officers and passengers of the "), _c('em', [_vm._v("Saragossa.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At breakfast Larkin managed to pick a quarrel with Jerry Butt, the most placid of souls, who had shown no disposition to argue or interfere with anyone, who, in fact, seemed perfectly happy as long as he could sit with his boon companion Ron Ferry and steadily, quietly, resolutely consume whisky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jerry was a stocky, short, baldish man who looked as though he had once been an athlete. Ron Ferry was a little older, though both were in their forties. Ferry was a flashier type who affected gay ties and bright tropical suits. Neither was at his best at the breakfast table, though both always appeared and drank their tea and ate their toast like men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("That morning Larkin began to hold forth on politics. He had been, it appeared, a member of Sir Oswald Mosley’s party before the war and regretted the days of street processions and rowdy meetings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t suppose you’ve ever belonged to any movement?” he said to Jerry Butt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jerry was not feeling like an argument. He had no recollection of reaching his bunk last night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Don’t look at me, old man,” he said equably.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m asking you!” shouted Larkin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Well, don’t,” said Jerry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Of course, if you’re such a dipsomaniac …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What was that word?” asked Jerry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I said dipsomaniac.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t like that word,” said Jerry mildly. “What does it mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It means a hopeless drunkard.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("“Oh, that’s all right,” said Jerry. “I thought it meant something else.”")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There was a sympathetic laugh from Mrs Roper and Prosper which seemed to rouse Larkin to further provocation. It was as though he were determined to antagonize everyone to the maximum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Gunner, the steward, asked Jerry if he would have another cup of tea, to which he assented.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What time do you start drinking?” asked Larkin unpleasantly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“As soon as I’ve finished this. What about you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m a strict teetotaller,” announced Larkin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Poor chap,” said Jerry with genuine and heartfelt sympathy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What do you mean, ‘poor chap’? Do you think it’s enviable to be in a state like yours? Half drunk from morning to night? Soaking spirits at every minute of the day? Do you "), _c('em', [_vm._v("like")]), _vm._v(" being like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yes,” said Jerry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He got another friendly laugh which further incensed Larkin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s a "), _c('em', [_vm._v("filthy")]), _vm._v(" state to be in!” he said. “Your liver must be in decay. Your whole bodily condition sodden and inflamed. You’ll probably not live another five years.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I feel fine,” said Jerry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You don’t look it. You look what you are, a hopeless drunkard. I suppose you get bouts of delirium tremens?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No, not really. A few lizards at times. Well, rather a lot. You know, all over the bed. But I haven’t seen them for a long time. Must have jumped in the sea.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("An extraordinary sound came from Larkin which was presumably intended to express amusement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“They’ll be back,” he said. “Plenty of them. You can’t soak like that without paying for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Who said I don’t pay for it? Never owed a penny in my life.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Suddenly Ronald Ferry with unsteady but genuine anger spoke to Larkin.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You’ve said enough,” he said. “Mind your own business.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ferry looked and sounded threatening. Even Larkin seemed to realize that he had gone too far.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I thought we were talking politics,” he said. “I remarked that I had belonged to the British Fascists before the war, and I’m still proud of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Better not say that when Mr Kutz is here,” warned Appleyard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“He’s not quite sane on the subject of Fascism. Or Communism either. Perhaps none of us would be if we had passed through what he has.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“These stories are usually grossly exaggerated,” said Larkin. But he seemed to grow thoughtful and gave his fellow-passengers a respite from his bellowing voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The morning passed without incident and when Apple-yard went up for a drink with the Captain before lunch he was able to report that there had been no dissension since breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You know, sir,” he said, “I’m beginning to think that this man Larkin has some reason of his own for deliberately provoking us all. It simply can’t be a natural thing. Nobody could be so offensive unless he planned to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I don’t know,” said Bidlake. “There are some pretty unpleasant people in the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“But not that unpleasant. I’m convinced it’s an act. Why should he go for a quiet and harmless man like Jerry Butt?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Embittered, perhaps. Can’t help it. Don’t forget what he’s going home to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Whatever it is, it makes the saloon hell. I hate the thought of going in to dinner. Thank heaven I’m on duty tonight.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("“Only two days more, though,” pointed out Captain Bidlake.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m afraid of what may happen in those two days.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Now, Appleyard, you’re imagining things again. What could happen?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Well, when I look at the faces round the table I’m inclined to think that anything could. Murder, even.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Bidlake looked grave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You mean that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m afraid I do, sir. If Larkin himself isn’t a killer—and I for one believe he is—he’s going the right way to turn someone else into one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No one kills a man just because he’s rude, Appleyard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It depends. However, as you say, two days more will see us home.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But that evening at dinner a climax was reached. Apple-yard was not present, or he would have been more than ever convinced that Larkin’s provocations were the result of a deliberate plan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The meal started quietly. Larkin had a large appetite and seemed to be chiefly interested in his food. Captain Bidlake talked with Mrs Roper on his right and she answered amiably, though in her usual clipped sentences. The two knew each other fairly well by now, for Mrs Roper was making the round trip and had been on the "), _c('em', [_vm._v("Saragossa")]), _vm._v(" for the best part of a month.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Is your husband meeting you on Thursday?” Bidlake asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No, poor boy. Too busy. Vicar’s away and he’s got the whole blasted parish on his hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Mr Roper, it will have been gathered, was a curate. He worked in Leeds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Wish he could have come. Done him good. Needs picking up. Try to get him out for a hike sometimes, but he won’t leave his work. Takes it too seriously. Conscientious. Hell of a life.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("“You don’t care for it?”")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Keep away. Told Phil I should before we married. Never make a she-parson out of me. Look after the old boy—that’s my job. Only been married a year.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Still nothing came from Larkin. But Jerry Butt evidently felt that he owed something to the conversation. He enunciated carefully, concentrating on the important matter of his sentence:")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Did I hear you say the other day that your husband worked in Leeds, Mrs Roper?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“S’right. St Hengist’s. Big parish.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jerry tried hard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I know Leeds,” he managed, but there, though everyone waited, his effort petered out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It was at this point that the volcano which was Larkin suddenly erupted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I was saying this morning, Mr Kutz, that I belonged to the British Fascists before the war, and I was told that you wouldn’t approve of that. Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There was a silence so complete that it seemed as though everyone had ceased to eat, certainly to move. Glances but no more went to Kutz.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One would have said he was the most composed person in the room. He looked steadily at Larkin with his cold, pale eyes. He made no answer and after ten seconds deliberately picked up his glass and drank, then continued calmly to eat his meal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Are you deaf?” shouted Larkin. “Or don’t you want to hear? Sometimes I think it was a pity we fought Hitler at all. He was the only man who knew how to deal with small nations. Perhaps you don’t agree?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Still there was not the slightest sign that Kutz had heard him. He finished what was on his plate and sat tranquilly indifferent to everything about him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This time it was Larkin who got up and walked out of the saloon.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("The situation was saved by Mrs Roper—and not for the first time. She turned to Jerry Butt.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Know it well?” she asked as though their conversation had never been interrupted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jerry looked startled at being addressed, but came up gamely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Intimately,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The meal went on, and when coffee was brought and Larkin did not return the little gathering in the saloon became almost cheerful. Then Gunner came in and spoke to Captain Bidlake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I think Mr Larkin’s gone to bed,” he said. “I took him a cup of coffee and his door was locked. He shouted to me to go away and I’m pretty sure his voice came from his bunk.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It seemed that Gunner was right, for Larkin did not appear again in the saloon that evening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Next day was the last at sea, for on the following morning they would enter the Thames and before evening, Captain Bidlake devoutly hoped, the last of the passengers would have left the ship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The sea was rough, but there was sunshine as they came up the Channel. Moreover, as if to make up for the rolling of the ship, there was a miraculous peace in the saloon. Larkin appeared, but seemed quite subdued. Breakfast and lunch passed without incident and dinner was only marked by a brief but unpleasant brush between Larkin and Gunner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Gunner was a thin but muscular man of thirty with a small moustache, a ready grin and a wallet full of photos of his wife and children which he was a little too ready to display. He had a pleasant though breezy manner with the passengers, whom he was inclined to shepherd about in a kindly but familiar way which most of them liked. He was never cheeky, but there was certainly nothing servile about him.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Prosper had bought champagne that evening, as it was ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("their last dinner on board, and Gunner made the mistake of pouring out a glass for Larkin.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Steward!” Larkin shouted. “What is this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Champagne, sir. With Mr Prosper.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Take it away and pour it down the sink. I don’t rot my gullet with filth like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Gunner remained quite equable and took the glass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’ll drink it myself,” he said with his usual grin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You’ll do nothing of the sort. You’ll obey my orders and pour it away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Couldn’t do that, sir. Lovely wine like this. It would be a sin.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Larkin jumped to his feet and knocked the glass out of Gunner’s hand, wetting the steward’s clean white jacket. Gunner did not completely lose his temper, but he was angry enough to ignore all the usual conventions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You keep your hands to yourself, cock,” he said, “and don’t start anything with me, else you "), _c('em', [_vm._v("will")]), _vm._v(" be in trouble. Sorry about the wine, Mr Prosper.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Larkin turned to the Captain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Do you allow your steward to insult passengers like that?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m afraid you rather asked for it, Mr Larkin,” said Captain Bidlake, and when Larkin had made a violent noise with his lips he sat down and said no more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Six hours later, at about two a.m., Appleyard was on the bridge with one of the apprentices, Dickie Bryce. It was a dark, rough night, blowing up for bad weather with already half a gale running and a thin sleet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Appleyard went down to the saloon and found it empty except for Gunner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“They’ve all gone to bed, thank God,” said Gunner, more devoutly than blasphemously. “The whole lot of them. It’s a treat to have them out of the way, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Captain was the only officer whom Gunner addressed as ‘sir’.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("“You’re right. No sound or sign of Larkin?”")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No. The bastard. Hear what he said to me tonight? I should like to ‘do’ him. But we’re quit of him tomorrow. He turned in about ten. Always locks his cabin door.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Appleyard ate some sandwiches and returned to the bridge. Young Bryce was on the starboard wing of the bridge and remained there. Appleyard hoped that he would get some decent weather ashore this trip. He would only have about forty-eight hours at home and he wanted to put up a pergola in the garden. He was thinking of this when suddenly above the wind he heard a high-pitched shout.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Man overboard!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Young Bryce yelled at him: “There is. I saw him go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Appleyard told the helmsman to put the helm up. He then rang down to the engine-room “Stop”, and reported to the Captain on the speaking-tube.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Man overboard, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You’ve stopped engines?” said Bidlake and began pulling on some clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Though he knew already that it could only be a piece of routine, Appleyard gave the order to the bo’sn to prepare a boat’s crew. He then went down to the saloon. Gunner was alone there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Who shouted?” Appleyard asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Don’t know. Someone on the starboard deck. I was in the galley, and when I came out there was no one in sight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Check up the passengers,” said Appleyard and hurrying back to the bridge sent Bryce to check on the crew. The Captain had come out on the bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Nothing to be done,” said Bidlake. “We’ll put the searchlight over the water, but it’s hopeless and I’m going ahead in five minutes. Whoever it was has had it. Shouldn’t think of lowering a boat in this sea and it’s no use turning about.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No, sir. Nothing we can do.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("The two of them were shouting at one another in the wind and sleet.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Young Bryce says he saw him. I can’t understand how he could have seen much. Someone shouted, but we don’t know yet who it was.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Hell! It only needed this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The searchlight played on the rolling black Channel waters, but revealed nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What’s the use? We’re wasting time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Shall I ring down to the engine-room, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“We’ll give them a few minutes more. It’ll look better in the report. But any fool could see it’s hopeless.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Gunner came up on the bridge, still in the wet rags of his white jacket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s Larkin!” he bawled. “His cabin door was unlocked and he’s gone. There’s a note on his table.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Bidlake turned to Appleyard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Full steam ahead,” he said.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-518a98e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Chapter02.vue
// module id = 72
// module chunks = 0